import { render, staticRenderFns } from "./wechat.vue?vue&type=template&id=6891e623"
import script from "./wechat.vue?vue&type=script&lang=js"
export * from "./wechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports